export enum BillingTabsEnum {
  INSURANCE = "insurance",
  SERVICES = "services",
  STATEMENTS = "statements",
  PAYMENTS = "payments",
}

/**
 * In-app URL for one tab of a client's Billing page. Callers that link to a client billing tab use
 * this helper so the path and the `tab` query param stay in one place.
 *
 * @param clientId - The client's Patient id.
 * @param tab - The Billing tab to open.
 * @returns The path, for example `/clients/client-1/billing?tab=insurance`.
 */
export function getClientBillingTabPath(clientId: string, tab: BillingTabsEnum): string {
  return `/clients/${clientId}/billing?tab=${tab}`;
}
